import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@mui/system';
import './CustomSplitter.css';

interface CustomSplitterProps {
    children: React.ReactNode[];
}

const CustomSplitter: React.FC<CustomSplitterProps> = ({ children }) => {
    const [sizes, setSizes] = useState([50, 50]);
    const containerRef = useRef<HTMLDivElement>(null);
    const isDragging = useRef(false);

    const handleMouseDown = () => {
        isDragging.current = true;
    };

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isDragging.current || !containerRef.current) return;

        const containerWidth = containerRef.current.offsetWidth;
        const newLeftWidth = (e.clientX / containerWidth) * 100;
        const newRightWidth = 100 - newLeftWidth;

        setSizes([newLeftWidth, newRightWidth]);
    };

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <Box className="splitter-container" ref={containerRef}>
            <Box className="splitter-pane" style={{ width: `${sizes[0]}%` }}>
                {children[0]}
            </Box>
            <Box className="splitter-divider" onMouseDown={handleMouseDown} />
            <Box className="splitter-pane" style={{ width: `${sizes[1]}%` }}>
                {children[1]}
            </Box>
        </Box>
    );
};

export default CustomSplitter;